import { authAPI } from './api';

export interface SupportTicket {
  id: string;
  company_id: string;
  user_id: string;
  title: string;
  description?: string;
  status: 'open' | 'in_progress' | 'waiting' | 'resolved' | 'closed';
  priority: 'low' | 'medium' | 'high' | 'urgent';
  assigned_to?: string;
  sla_deadline?: string;
  resolved_at?: string;
  created_at: string;
  updated_at: string;
}

export interface SupportMetrics {
  company_id: string;
  open_tickets: number;
  in_progress_tickets: number;
  resolved_this_month: number;
  sla_breached: number;
  avg_resolution_hours?: number;
}

export interface SLAPolicy {
  company_id: string;
  response_hours: number;
  resolution_hours: number;
  plan_tier: string;
}

export interface KBArticle {
  id: string;
  title: string;
  content: string;
  version: number;
}

export async function listTickets(status?: string) {
  const params = status ? { status } : {};
  const res = await authAPI.get('/support/tickets', { params });
  return res.data.tickets as SupportTicket[];
}

export async function createTicket(data: { title: string; description?: string; priority?: string }) {
  const res = await authAPI.post('/support/tickets', data);
  return res.data as SupportTicket;
}

export async function updateTicket(id: string, data: { status?: string; priority?: string; assigned_to?: string }) {
  const res = await authAPI.patch(`/support/tickets/${id}`, data);
  return res.data as SupportTicket;
}

export async function getSupportMetrics() {
  const res = await authAPI.get('/support/metrics');
  return res.data as SupportMetrics;
}

export async function getSLAPolicy() {
  const res = await authAPI.get('/support/sla');
  return res.data as SLAPolicy;
}

export async function listKBArticles() {
  const res = await authAPI.get('/support/kb');
  return res.data.articles as KBArticle[];
}

export async function addTicketComment(ticketId: string, body: string) {
  const res = await authAPI.post(`/support/tickets/${ticketId}/comments`, { body });
  return res.data;
}
